import axios from 'axios'
import { Message } from 'element-ui'

// 创建axios实例
axios.defaults.baseURL = process.env.VUE_APP_BASE_API // api 的 base_url
axios.defaults.timeout = 10000 // 请求超时时间
axios.defaults.withCredentials = true

// request拦截器
axios.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
    return config
  },
  error => {
    // 请求出现错误
    console.log(error)
    return Promise.reject(error)
  }
)

// response拦截器
axios.interceptors.response.use(
  response => {
    const res = response.data

    // 请求成功
    if (res.resultCode === 1) {
      return Promise.resolve(res)
    }

    // 请求失败，显示错误信息
    Message({
      message: res.message || '请求失败',
      type: 'error',
      duration: 2 * 1000
    })

    return Promise.reject(res)
  },
  error => {
    console.log('err' + error)
    Message({
      message: error.message || '网络请求错误',
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

const service = ({ url, method, data = {} } = {}) => {
  const config = {
    url,
    method: method || 'post'
  }

  if (method && method.toLowerCase() === 'get') {
    config.params = data
  } else {
    config.data = data
  }

  return axios(config)
}

export default service
